import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
    Button,
    TextField,
    CircularProgress,
    Typography,
} from "@material-ui/core";

import FloatingContainer from "src/shared_modules/veu-visitors-core/components/common/container/floatingContainer";
import ScrollContainer from "src/shared_modules/veu-visitors-core/components/common/container/scrollContainer";

import {
    Translate
} from "src/shared_modules/i18n";

import {
    showPopover,
    hidePopover,
} from 'src/shared_modules/veu-visitors-core/actions/popovers';

import {
    requestNewPassword
} from 'src/shared_modules/veu-visitors-core/actions/user';

import './user.css';


class PopoverForgot extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            canSend: false,
            isBusy: false,
            wasSend: false,
            fields: {
                username: "",
            }
        }
    }

    componentDidMount() {

    }

    clickCancel() {
        this.setState({
            isBusy: false,
            fields: { username: "" },
            canSend: false,
            wasSend: false,
        });
        this.props.hidePopover("Forgot");
        this.props.showPopover("Login");
    }

    async clickSend() {
        if (this.state.isBusy || !this.state.canSend)
            return;

        this.setState({
            isBusy: true,
        });

        await this.props.requestNewPassword(
            this.state.fields,
        );

        this.setState({
            isBusy: false,
            wasSend: true,
        });
    }

    validateInput(value) {
        // just not empty
        if (value === undefined || value === null || value.trim() === "")
            return false;

        return true;
    }

    handleInputChange(field, event) {
        event.preventDefault();
        // update the field value
        let fields = this.state.fields;
        let val = event.target.value;
        fields[field] = val;

        let canSend = true;

        if (!this.validateInput(fields["username"]))
            canSend = false;

        this.setState({
            fields: fields,
            canSend: canSend,
        });
    }

    renderStep1() {
        // ask for email and send email

        // IMPORTANT :
        // this here is need because of a "bug" in ClickAwayListener
        // which steals the focus of an Textfield during input.
        let focusEmail = false;
        if (this.state.focus === "email")
            focusEmail = true;

        return (<form onSubmit={(e) => { e.preventDefault(); }} >
                <Typography variant="h6" component="h1" color="primary" className="user-form">
                    <Translate>popovers.forgotLogin.titleStep1</Translate>
                </Typography>
                <Typography variant="caption" component="div" className="light-grey-text">
                    <Translate>popovers.forgotLogin.noteStep1</Translate>
                </Typography>
                <p></p>
                <TextField id="email" key="email"
                    autoFocus={focusEmail}
                    required
                    fullWidth
                    label={<Translate>person-labels.username</Translate>}
                    variant="outlined"
                    value={this.state.fields["username"]}
                    onChange={(e) => { this.handleInputChange("username", e); }}
                />

                <div className="user-form-button-bar">
                    <Button variant="contained"
                        size="large"
                        color="secondary"
                        onClick={() => { this.clickSend(); }}
                        disabled={!this.state.canSend}
                        type="submit"
                        endIcon={this.state.isBusy && <CircularProgress color="inherit" size={20} />}
                    >
                        <Translate>popovers.forgotLogin.send</Translate>
                    </Button>
                    <Button size="large"
                        color="primary"
                        onClick={() => { this.clickCancel(); }}
                    >
                        <Translate>popovers.forgotLogin.cancel</Translate>
                    </Button>
                </div>
            </form>);
    }

    renderStep2() {
        // show hint ...
        return (<React.Fragment>
                <Typography variant="h6" component="h1" color="primary" className="user-form">
                    <Translate>popovers.forgotLogin.titleStep2</Translate>
                </Typography>
                <Typography variant="body2" component="div">
                    <Translate>popovers.forgotLogin.noteStep2</Translate>
                </Typography>
                <p></p>
                <div className="user-form-button-bar">
                    <Button variant="contained"
                        size="large"
                        color="secondary"
                        onClick={() => { this.clickCancel(); }}
                    >
                        <Translate>popovers.forgotLogin.done</Translate>
                    </Button>
                </div>
            </React.Fragment>);
    }

    render() {
        if (!this.props.showForgot)
            return (null);

        return (<FloatingContainer position="center"
                    width="sm"
                    fsSwitch="xs"
                    className="user outer-flex-scroll-container user-login"
                    modal
                    onClickAway={() => { this.clickCancel(); }}
                    largeBottomPadding={this.props.event.hasUserlike}
                >
                    <ScrollContainer className="user-login">
                        { !this.state.wasSend && this.renderStep1() }
                        { this.state.wasSend && !this.state.isBusy && this.renderStep2() }
                    </ScrollContainer>
                </FloatingContainer>);
    }
}

PopoverForgot.propTypes = {
    showForgot: PropTypes.bool,
    event: PropTypes.object,
};


/*
 * ---------------------------------------------------------------------
 * PopoverLogin Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = (state, ownProps) => {
    return {
        showForgot: state.popovers.showForgot,
        event: state.event,
    };
};
const mapDispatchToProps = {
    showPopover,
    hidePopover,
    requestNewPassword,
};

/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PopoverForgot);
